export type PreviewSplitArm = "control" | "treatment";

export function markerForArm(arm: PreviewSplitArm) {
    if (arm === "treatment") {
        return {
            arm,
            label: "TREATMENT",
            background: "#ff4d00",
            color: "#1a1a1a",
        };
    }
    return {
        arm: "control" as const,
        label: "CONTROL",
        background: "#102033",
        color: "#f4f7fb",
    };
}
